module.exports = __webpack_public_path__ + "media/thief-in-the-night.fbc90261.mp3";